import Translation from '../components/markup/Translation';
import languageContainer from './languageContainer';

export default languageContainer(Translation);
